import Vue from 'vue'
import fetch from '@/apis/index'
import { isDDEnv, isWXEnv, isGDTEnv } from '@/utils/env'
import * as filters from '@/filters/index'
// 引入版本信息
import globalConfig from '../package.json'

// 引入iconfont
import '../static/icons/iconfont.css'
import '../static/icons/iconfont.js'

Vue.config.productionTip = false

Vue.prototype.$fetch = fetch.request
Vue.prototype.isDDEnv = isDDEnv()
Vue.prototype.isWXEnv = isWXEnv()
Vue.prototype.isGDTEnv = isGDTEnv()
Vue.prototype.globalConfig = {
  version: globalConfig && globalConfig.version ? globalConfig.version : ''
}
// 全局环境变量
Vue.prototype.$APP_CONFIG = process.env.APP_CONFIG

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})



// WEBPACK FOOTER //
// ./src/global.js